// extracted by mini-css-extract-plugin
module.exports = {"container":"StatSwitch_container__2pfqz","buttons-group":"StatSwitch_buttons-group__B63td","button":"StatSwitch_button__3QP9g"};